import { ColorFill, Component, Container, FontWeight, Text } from '@tencent/alloy-renderer';
import {
    InterfaceRendererShapeComponent,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/types';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { ptToCanvas } from '@src/slide/infrastructure/module/independent/unit';
import { addonDefaultIcon } from './icons';
import { convertColor } from '../text-editor/utils/color';
import { PlayerIconComponent } from './index';
import i18n from '@i18next/i18n';
import { isIframeShapeModel } from '@src/slide/domain/ui-model/elements/element-judge';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';

export const AddonDoNotAddIconList = ['e0b026441751437d8b0c45ff29b508c3', 'bb159a4f513f4f70afc5773acb5deefd_pre'];
export class IframeIconComponent extends PlayerIconComponent {
    // 基础graphics部分
    public readonly parentComponent: InterfaceRendererShapeComponent;
    declare public factoryOptions: InterfaceFactoryOptions<IShapeModel>;

    public constructor(
        factoryOptions: InterfaceFactoryOptions<IShapeModel>,
        parentComponent: InterfaceRendererShapeComponent,
    ) {
        super(factoryOptions, parentComponent);
        this.parentComponent = parentComponent;
    }

    public updateComponent = (): void => {
        const { model } = this.factoryOptions;
        if (isIframeShapeModel(model)) {
            this.renderFlagIcon();
        } else {
            this.removeFlagGraphics();
        }
    };

    // 设置icon到画布上
    protected renderFlagIcon = () => {
        const { model } = this.factoryOptions;
        // FIXME: 临时方案，硬编码去掉酷狗与qq频道的icon
        if (AddonDoNotAddIconList.indexOf(model.props?.addon?.iframeId ?? '') > -1) {
            return;
        }
        const { iconGraphic } = this.getFlagGraphics();
        if (!this.flagGraphics) {
            // 没有则创建
            this.flagGraphics = new Component();
            this.flagGraphics.addChild(iconGraphic);
            this.parentComponent.addChild(this.flagGraphics);
        } else {
            const sizeCollect = this.getFlagGraphicsSize();
            if ((this.flagGraphics.children[0] as Container)?.children.length === 1) {
                this.flagGraphics.removeChild(this.flagGraphics.children[0]);
                this.flagGraphics.addChild(iconGraphic);
            }
            const { x, y } = sizeCollect.iconGraphicPosition;
            // 更新播放小图标的坐标
            this.flagGraphics.children[0].x = x;
            this.flagGraphics.children[0].y = y;
        }
    };

    protected getFlagGraphicsSize = () => {
        const addonInfo = this.getAddonInfo();
        const needAddText = addonInfo && !addonInfo.isOfficial;
        const backgroundGraphicsSize = { width: ptToCanvas(48), height: needAddText ? ptToCanvas(74) : ptToCanvas(48) };
        const { width, height } = this.factoryOptions.frame!;
        return {
            iconGraphicPosition: {
                x: (width / 2) - (backgroundGraphicsSize.width / 2),
                y: (height / 2) - (backgroundGraphicsSize.height / 2),
            },
        };
    };

    // 生成图标graphic
    protected getFlagGraphics = () => {
        const iconGraphic = this.getIconGraphic();

        const addonInfo = this.getAddonInfo();
        if (addonInfo && !addonInfo.isOfficial) {
            this.addTipsText(iconGraphic);
        }
        return {
            iconGraphic,
        };
    };

    protected getImgStyle() {
        let addonIcon = addonDefaultIcon;
        const addonInfo = this.getAddonInfo();
        if (addonInfo && !addonInfo?.isOfficial) {
            addonIcon = addonInfo.icons.small;
        }
        // icon图片
        return {
            fillBackground: {
                image: {
                    src: addonIcon,
                },
            },
            width: ptToCanvas(48),
            height: ptToCanvas(48),
        };
    }

    private addTipsText(flagGraphics: Container) {
        const textNode = new Text(i18n.t('点击加载插件'));
        textNode.x = ptToCanvas(-12);
        textNode.y = ptToCanvas(60);
        textNode.fontSize = ptToCanvas(12);
        textNode.fontWeight = FontWeight.Normal;
        textNode.fill = new ColorFill(convertColor('#0000007a'));
        flagGraphics.addChild(textNode);
    }

    private getAddonInfo() {
        const { model } = this.factoryOptions;
        const addonHandler = this.factoryOptions.addonManager?.addonHandler;
        if (addonHandler) {
            const iframeId = model.props.addon?.iframeId ?? '';
            const addonInfo = addonHandler.addonInfoMap.get(iframeId);
            return addonInfo;
        }
        return null;
    }
}
